import React from 'react';
import PropTypes from 'prop-types';

import Label from '../../../../../../components/Label';
import Input from '../../../../../../components/Input';

const CashbackRatesForm = (props) => {
  const { values, onChange, errors } = props;
  return (
    <div>
      <div className="input">
        <Label
          name="defaultCashbackRate"
          title="Default Cashback Rate"
          errors={errors}
        />
        <Input
          id="defaultCashbackRate"
          type="number"
          value={values.defaultCashbackRate}
          onChange={onChange}
          min="1"
          max="100"
        />
      </div>
      <div className="input">
        <Label
          name="birthdayCashbackRate"
          title="Birthday Cashback Rate"
          errors={errors}
        />
        <Input
          id="birthdayCashbackRate"
          type="number"
          value={values.birthdayCashbackRate}
          onChange={onChange}
          min="1"
          max="100"
        />
      </div>
    </div>
  );
};

export default CashbackRatesForm;

CashbackRatesForm.propTypes = {
  values: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({}),
};

CashbackRatesForm.defaultProps = {
  errors: {},
};
